import { render, staticRenderFns } from "./PeerReviewOverviewTable.vue?vue&type=template&id=b36b0f0e&scoped=true&"
import script from "./PeerReviewOverviewTable.vue?vue&type=script&lang=js&"
export * from "./PeerReviewOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./PeerReviewOverviewTable.vue?vue&type=style&index=0&id=b36b0f0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b0f0e",
  null
  
)

export default component.exports